import React, {Component} from 'react';

import {Select, Spin, Form, Modal} from 'antd';

import services from '../../services';

const FormItem = Form.Item;

export default class UserRemoteSelect extends Component{
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            value: [],
            fetching: false,
        }
    }

    fetchUser(value) {
        this.querySearch(value);
    }

    querySearch(value) {
        this.setState({
            data: [],
            fetching: false
        });


        return services.employee
        .querySearchByName({orgId: this.orgId, realName: value})
        .then((data) => {
            this.setState({
                data,
                fetching: false
            })
        });
    }

    onFocus() {
        if(this.orgId) {
            this.querySearch('');
        } else {
            this.refs.select.blur();
            Modal.error({
                title: '请先选择部门',
                content: (
                    <div>
                    <p>只有请先选择部门后才能后续操作！</p>
                    </div>
                ),
                onOk() {},
            });
        }
    }

    onChange(value, data) {
        this.setState({
            value,
            data: [],
            fetching: false,
        });

        if(this.props.handleChange) {
            this.props.handleChange({
                employeeId: value.key,
                realName: value.label
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('orgId')) {
            this.orgId = nextProps.orgId;
        }
    }

    render() {
        const { style, label, disabled } = this.props;
        const { fetching, data, value } = this.state;
        return (
            <FormItem  label={label || "教师"}>
                <Select
                    allowClear={true}
                    ref="select"
                    showSearch
                    disabled={disabled}
                    labelInValue
                    value={value}
                    placeholder={'请输入...'}
                    notFoundContent={fetching ? <Spin size="small" /> : null}
                    filterOption={false}
                    onSearch={this.fetchUser.bind(this)}
                    onChange={this.onChange.bind(this)}
                    onFocus={this.onFocus.bind(this)}
                    dropdownMatchSelectWidth={false}
                    style={style || {width: 240}}
                    >
                    {data.map(d => <Option key={d.value}>{d.label}</Option>)}
                </Select>
            </FormItem>
            
        );
    }
}